import { Component } from '@angular/core';
import {
	DEFAULT_POPUP_CONFIG,
	DroplistWidget,
	PageTab1Directive,
	PageTab2Directive,
	PageTabsLayout,
	PageTabsWidget
} from '@eforall/dashboard';
import { TrimesterWindowEnum } from '@interfaces';
import { ToolbarWidget } from '../../../ui/widget';
import { DevoDonorsPageService } from './devo-donors.page.service';
import { DevoDonorsTab1Part } from './tabs/tab-1/devo-donors-tab-1.part';
import { DevoDonorsTab2Part } from './tabs/tab-2/devo-donors-tab-2.part';
import { DevoDonorsViewsPart } from './views/devo-donors-views.part';

@Component({
	selector: 'devo-donors-page',
	standalone: true,
	imports: [
		DevoDonorsTab1Part,
		DevoDonorsTab2Part,
		DevoDonorsViewsPart,
		PageTab1Directive,
		PageTab2Directive,
		PageTabsWidget,
		DroplistWidget, ToolbarWidget,],
	templateUrl: './devo-donors.page.html',
})
export class ConfigurationPlanningPage {

	public popupConfig = DEFAULT_POPUP_CONFIG;
	public readonly trimesterWindow = TrimesterWindowEnum.Programming;

	constructor(public pageService: DevoDonorsPageService) { }

	onLayoutChange(layout: PageTabsLayout) {
		this.pageService.changeLayout(layout);
	}

}